// src/forms/companyProfileConfig.js

const DeleteConfig = [
    
        {
            name: 'deactivate_reason',
            label: 'Deactive Reason',
            type: 'select',
            defaultValue: '',

            options: [
                { value: '', label: 'Enter Deactivate Reason' },
                { value: 'resignation', label: 'Resignation' },
                { value: 'retirement ', label: 'Retirement' },
                { value: 'pursuit of further education', label: 'Pursuit of further education' },
                { value: 'Career change', label: 'Career change' },
                { value: 'Family reasons', label: 'Family reasons' },
                { value: 'Sickness', label: 'Sickness' },
                { value: 'Layoff', label: 'Layoff' },
                { value: 'Termination for cause', label: 'Termination for cause' },
                { value: 'End of contract', label: 'End of contract' },
                { value: 'Death', label: 'Death' },
                { value: 'Disability', label: 'Disability' },
                { value: 'Mutual agreemen', label: 'Mutual agreemen' },
                { value: 'error_correction', label: 'Error Correction' },
            
                ],
                    
            rules: { required: 'Reason  is required' },
          },
          {
            name: 'deactivate_date',
            label: 'Deactive Date',
            type: 'date',
            defaultValue: '',
            placeholder: 'Enter Deactivate  date',
            rules: { required: 'Delete date is required' },
          },
      
];
export default DeleteConfig;
  